export default `float e=0.7;
  float s=5.0;
  float u;
  float t = 65.0; 
  for(int j=0;j++<12;p.xz=mod(p.xz-1.,2.)-1.)
    s/=u=dot(p,p),
    p/=-u,
    p.x=sin(t)*.25-p.x,
    p.z=cos(t)*.25-p.z,
    p.y+=1.75,
    e=min(e,p.y/s);
  return e;
}`